import { motion } from 'framer-motion';
import EmployeeCard from './EmployeeCard';
import { EmptySearchState } from './ui/EmptyState';

function EmployeeList({ employees, searchTerm = '', onDelete, onUpdate }) {
  if (!employees || employees.length === 0) {
    return <EmptySearchState searchTerm={searchTerm} />;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
    >
      {employees.map((emp) => (
        <EmployeeCard
          key={emp.id}
          employee={emp}
          isNew={Boolean(emp.__isNew)}
          onDelete={onDelete}
          onUpdate={onUpdate}
        />
      ))}
    </motion.div>
  );
}

export default EmployeeList;
